import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {HorribleHeroesParsedGameData} from "../../../server/data/HorribleHeroesParsedGameData";
import {TimelineLite} from "gsap";
import {HorribleHeroesGameModuleConfig} from "../../../HorribleHeroesGameModuleConfig";

export class HHRandomWild implements GameRoundPresentation {
    public getAnimation(data: HorribleHeroesParsedGameData): TimelineLite {
        return new TimelineLite().add(() => HorribleHeroesGameModuleConfig.randomWildView.playAnimation());
    }
}